/* FloorEver — en-tête (sections/floorever-header.liquid).
 *
 * Menu burger (<details class="header-burger">) : se ferme avec Échap (le
 * focus revient sur son bouton), d'un clic en dehors, ou quand le focus
 * clavier quitte le panneau. Sans JS, le <details> reste utilisable.
 * Audit du 17/10/2026 : le panneau ne se fermait qu'avec son propre bouton,
 * et depuis que le burger sert jusqu'à 1 099 px, il pouvait masquer
 * l'élément qui recevait le focus.
 */
(function () {
  'use strict';

  function init() {
    var burger = document.querySelector('.header-burger');
    if (!burger || burger.dataset.burgerInit === '1') return;
    burger.dataset.burgerInit = '1';
    var bouton = burger.querySelector('summary');

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.open) {
        burger.open = false;
        if (bouton) bouton.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (burger.open && !burger.contains(e.target)) burger.open = false;
    });

    burger.addEventListener('focusout', function (e) {
      if (burger.open && e.relatedTarget && !burger.contains(e.relatedTarget)) burger.open = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', init);
})();
